/* LBDM - correctifs (14/10/2026). Retirer en supprimant la ligne lbdm-fixes.js dans layout/theme.liquid. */
(function () {
  function run() {
    /* Faute dans le bandeau d'annonce ("dés" -> "dès"). A corriger aussi dans Personnaliser > bandeau d'annonce. */
    document.querySelectorAll('.announcement-bar_text, .x-announcement-bar-block-data').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (/dés\s+\d/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/dés(\s+\d)/g, 'dès$1');
      }
    });
    /* Un seul H1 par page : sur l'accueil, le logo de l'en-tete passe en div. */
    if (document.querySelector('.lbdm-hero h1')) {
      document.querySelectorAll('header h1').forEach(function (h) {
        var d = document.createElement('div');
        d.className = h.className;
        while (h.firstChild) d.appendChild(h.firstChild);
        h.replaceWith(d);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
